import { render, staticRenderFns } from "./AssetColorPicker.vue?vue&type=template&id=1b7eef36&scoped=true"
import script from "./AssetColorPicker.vue?vue&type=script&lang=ts"
export * from "./AssetColorPicker.vue?vue&type=script&lang=ts"
import style0 from "./AssetColorPicker.vue?vue&type=style&index=0&id=1b7eef36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7eef36",
  null
  
)

export default component.exports